
import { AggregatedData } from "./types";

export const transformDataForExport = (
  aggregatedData: AggregatedData[], 
  languages: string[], 
  showProductDetails: boolean = false
) => {
  return aggregatedData.map(item => {
    const exportItem: Record<string, string> = {
      'Article Number': item.articleNumber,
      'Product Name': item.originalText,
      'Generated Description': item.generatedDescription,
    };

    // Conditionally add Product Details column
    if (showProductDetails) {
      exportItem['Product Details'] = item.productDetails;
    }

    // Add translation columns with proper headers
    languages.forEach(lang => {
      exportItem[`Translation (${lang.toUpperCase()})`] = item[`translation_${lang}`];
      
      // Only add translation details if showProductDetails is true
      if (showProductDetails) {
        exportItem[`Translation Details (${lang.toUpperCase()})`] = item[`translation_details_${lang}`];
      }
    });

    return exportItem;
  });
};
